export default {
  nameBudget: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  emailBudget: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  cellNumberBudget: {
    value: '',
    maxlength: '30',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/mechanicalworkshop/budget/mechanicalworkshopbudget-form.js